import { ENVInterface } from './common';

const Production: ENVInterface = {
    FRONT_ORIGIN: "https://surprisebox.jp",
    API_ORIGIN: "https://api.surprisebox.jp",
    API_CONFIG: {
        validateStatus: (status: number) => {
            return true;
        },
        withCredentials: true,
    },
    GOOGLE_ANALYTICS: "UA-61304086-4",
};

export default Production;
